/* ============================================================================
   <hbno-carousel> — minimal horizontal scroller for the In-Stock product rail.
   Presentation only: it scrolls the existing product cards left/right. All
   cart / variant / review behaviour stays in the theme's product-card + cart
   components. No dependencies.
   ========================================================================== */
class HbnoCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    if (!this.track) return;

    this.prevBtn = this.querySelector('[data-prev]');
    this.nextBtn = this.querySelector('[data-next]');

    this.onPrev = () => this.scrollByCards(-1);
    this.onNext = () => this.scrollByCards(1);
    this.onScroll = () => this.updateArrows();

    if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrev);
    if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNext);
    this.track.addEventListener('scroll', this.onScroll, { passive: true });

    this.updateArrows();
  }

  disconnectedCallback() {
    if (this.prevBtn) this.prevBtn.removeEventListener('click', this.onPrev);
    if (this.nextBtn) this.nextBtn.removeEventListener('click', this.onNext);
    if (this.track) this.track.removeEventListener('scroll', this.onScroll);
  }

  scrollByCards(direction) {
    const card = this.track.firstElementChild;
    const step = card ? card.getBoundingClientRect().width + 20 : this.track.clientWidth * 0.8;
    this.track.scrollBy({ left: step * direction, behavior: 'smooth' });
  }

  updateArrows() {
    const maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;
    if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 0;
    if (this.nextBtn) this.nextBtn.disabled = this.track.scrollLeft >= maxScroll;
  }
}

if (!customElements.get('hbno-carousel')) {
  customElements.define('hbno-carousel', HbnoCarousel);
}
